import { faEye, faHistory } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription } from "react-bootstrap-table-next";
import ExportExcel from "../../../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../../../Components/Table";
import {
    ListarAtendimentosController,
    ListarAtendimentosExportarExcelController,
} from "../../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../../hooks/usePaginationFilter";
import {
    IListarTodosAtendimentos,
    ILstCasos,
} from "../../../../../Interfaces/AtendimentoCliente/Atendimento/AtendimentoInterfaces";
import { TModoGestaoAtendimento } from "../../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import FiltroAtendimentosGeral from "./FiltroAtendimentosGeral";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import HistoricoCardPage from "../../../../../Components/CardsPages/Historico";
import ModalComponent from "../../../../../Components/Modais";

interface ITodosAtendimentosProps {
    atendimento: TModoGestaoAtendimento;
}

export default function ListaTodosAtendimentos(props: ITodosAtendimentosProps) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<IListarTodosAtendimentos>();

    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );

    const FILTRO_GESTAO_TODOS_ATENDIMENTOS_GERAL = sessionStorage.getItem(
        `FILTRO_GESTAO_TODOS_ATENDIMENTOS_GERAL_${props.atendimento}`
    );

    const filtroInicial = {
        DT_INICIAL_IN: "",
        DT_INICIAL_FN: "",
        DT_FINAL_IN: "",
        DT_FINAL_FN: "",
        DS_STATUS_CASO: "Aberto",
        ID_CASO: "",
        ID_CONTA: 0,
        ID_USUARIO: "",
        DS_NOME_CONTA: "",
        DS_NOME_CONTATO: "",
        ID_ACOMPANHAMENTO: 0,
    };

    const handleDateChange = (formData: IListarTodosAtendimentos) => {
        const filterFormData = {
            ...formData,
            DT_INICIAL_IN: formData.DT_INICIAL_IN ?? "",
            DT_INICIAL_FN: formData.DT_INICIAL_FN ?? "",
            DT_FINAL_IN: formData.DT_FINAL_IN ?? "",
            DT_FINAL_FN: formData.DT_FINAL_FN ?? "",
            DS_STATUS_CASO: formData.DS_STATUS_CASO ?? "",
            ID_CASO: String(formData.ID_CASO) ?? "0",
            ID_CONTA: formData.ID_CONTA ?? 0,
            ID_USUARIO: formData.ID_USUARIO ?? "0",
            DS_NOME_CONTA: formData.DS_NOME_CONTA ?? "",
            DS_NOME_CONTATO: formData.DS_NOME_CONTATO ?? "",
            ID_ACOMPANHAMENTO: formData.ID_ACOMPANHAMENTO ?? 0,
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            `FILTRO_GESTAO_TODOS_ATENDIMENTOS_GERAL_${props.atendimento}`,
            JSON.stringify(filterFormData)
        );
    };

    const columnsAtendimentos: Array<ColumnDescription<ILstCasos>> = [
        {
            dataField: "DUMMY_FIELD",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-atendimento-tooltip">
                            Ver Histórico
                        </Tooltip>
                    }
                >
                    <button
                        className="m-2 btn btn-icon btn-outline-info"
                        onClick={() => {
                            setModal({
                                Component: () =>
                                    HistoricoCardPage({
                                        ID_CASO: row.ID_CASO,
                                    }),
                                headerComponent: "Históricos",
                                IconHeader: faHistory,
                                collapseForm: true,
                                size: "lg",
                            });
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </button>
                </OverlayTrigger>
            ),
        },
        {
            headerAlign: "center",
            dataField: "ID_CASO",
            text: "ID Caso",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_NOME_ATENDENTE",
            text: "Atendente",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_PRODUTO_COMP",
            text: "Produto",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_STATUS_CASO",
            text: "Status Caso",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_TIPO_CASO",
            text: "Tipo Caso",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_ULTIMO_HISTORICO",
            text: "Último Histórico",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_DESCRICAO_CASO",
            text: "Descrição",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_NOME_CLIENTE",
            text: "Cliente",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_NOME_CONTATO",
            text: "Nome Contato",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_EMAIL_CLIENTE",
            text: "Email Cliente",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_ETAPA",
            text: "Etapa",
            align: "center",
        },
    ];

    const { value: lstAtendimentos, loading: lstAtendimentosLoading } =
        useAsyncEffect(
            () =>
                ListarAtendimentosController(
                    PageFilter.page,
                    props.atendimento,
                    {
                        ...filter,
                        DS_NOME_CONTA: filter?.DS_NOME_CONTA ?? "",
                        DS_NOME_CONTATO: filter?.DS_NOME_CONTATO ?? "",
                        DS_STATUS_CASO: filter?.DS_STATUS_CASO ?? "",
                        DT_FINAL_FN: filter?.DT_FINAL_FN ?? "",
                        DT_FINAL_IN: filter?.DT_FINAL_IN ?? "",
                        DT_INICIAL_FN: filter?.DT_INICIAL_FN ?? "",
                        DT_INICIAL_IN: filter?.DT_INICIAL_IN ?? "",
                        ID_ACOMPANHAMENTO: filter?.ID_ACOMPANHAMENTO ?? 0,
                        ID_CASO: filter?.ID_CASO
                            ? String(filter?.ID_CASO)
                            : "0",
                        ID_CONTA: filter?.ID_CONTA ?? 0,
                        ID_USUARIO: filter?.ID_USUARIO
                            ? String(filter?.ID_USUARIO)
                            : "0",
                        ID_EMPREENDIMENTO: idEmpreendimento ?? [],
                    }
                ),
            [PageFilter, filter]
        );

    const totalPaginas = lstAtendimentos?.PAGINAS
        ? lstAtendimentos?.PAGINAS
        : 1;

    return (
        <div className="card card-custom">
            <div className="card-body mt-n2 table-responsive">
                <Table
                    columns={columnsAtendimentos}
                    data={lstAtendimentos?.lstCasos ?? []}
                    keyField="ID_CASO"
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    tableView={{
                        columns: columnsAtendimentos,
                        noSort: true,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                    }}
                    remote={{ pagination: true }}
                    totalPages={totalPaginas}
                    loading={lstAtendimentosLoading}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum Atendimento encontrado
                        </div>
                    )}
                    noHover
                    noSearch
                    bordered={false}
                />
            </div>
            <FiltroAtendimentosGeral
                filter={filter}
                filtroInicial={filtroInicial}
                setFilter={setFilter}
                FILTRO_GESTAO_TODOS_ATENDIMENTOS_GERAL={
                    FILTRO_GESTAO_TODOS_ATENDIMENTOS_GERAL
                }
                setPage={setPage}
                handleDateChange={handleDateChange}
                setIdEmpreendimento={setIdEmpreendimento}
            />

            <ExportExcel
                baixarExcelController={async () =>
                    ListarAtendimentosExportarExcelController(
                        0,
                        props.atendimento,
                        {
                            ...filter,
                            DS_NOME_CONTA: filter?.DS_NOME_CONTA ?? "",
                            DS_NOME_CONTATO: filter?.DS_NOME_CONTATO ?? "",
                            DS_STATUS_CASO: filter?.DS_STATUS_CASO ?? "",
                            DT_FINAL_FN: filter?.DT_FINAL_FN ?? "",
                            DT_FINAL_IN: filter?.DT_FINAL_IN ?? "",
                            DT_INICIAL_FN: filter?.DT_INICIAL_FN ?? "",
                            DT_INICIAL_IN: filter?.DT_INICIAL_IN ?? "",
                            ID_ACOMPANHAMENTO: filter?.ID_ACOMPANHAMENTO ?? 0,
                            ID_CASO: filter?.ID_CASO
                                ? String(filter?.ID_CASO)
                                : "0",
                            ID_CONTA: filter?.ID_CONTA ?? 0,
                            ID_USUARIO: filter?.ID_USUARIO
                                ? String(filter?.ID_USUARIO)
                                : "0",
                            ID_EMPREENDIMENTO: idEmpreendimento ?? [],
                        },
                        true
                    )
                }
                nomeArquivo={`Atendimento_${props.atendimento}`}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
